import { Redirect } from '#app/components/Redirect/index.js';
import { useCurrentUser } from '#app/hooks/useCurrentUser.js';
import { useLocation } from '#app/hooks/useLocation.js';
import { useSelectedUserType } from '#app/hooks/useSelectedUserType.js';
import { useURLParameters } from '#app/hooks/useURLParameters.js';
import { appendSearch } from '#app/utilities/appendSearch.js';
import { getRoute } from '@contra/routes';

export const Page = () => {
  const {
    routeHelpers: { selectedUserTypeRouteBase },
  } = useSelectedUserType();

  const [urlSearchParameters] = useURLParameters('/wallet');
  const addPayoutMethod = urlSearchParameters.addPayoutMethod;

  const currentUser = useCurrentUser();

  const location = useLocation();

  if (!currentUser || !selectedUserTypeRouteBase) {
    return (
      <Redirect
        method="replace"
        to={getRoute('/log-in', {
          search: {
            redirectTo: addPayoutMethod
              ? appendSearch(location.pathname, {
                  addPayoutMethod: true,
                })
              : location.pathname,
          },
        })}
      />
    );
  }

  return (
    <Redirect
      method="replace"
      to={getRoute('/@userType/wallet', {
        args: {
          userType: selectedUserTypeRouteBase,
        },
        search: {
          addPayoutMethod,
        },
      })}
    />
  );
};
